<template>
  <div>
    <!--    <div-->
    <!--        class="vue_toogle_panels"-->
    <!--        @click="vueTooglePanels = !vueTooglePanels" >-->
    <!--      <i class="material-icons" >view_headline</i >-->
    <!--    </div >-->

    <q-layout
        view="hHh Lpr lff"
        container
        style="height:calc(100vh - 66px)"
        :class="'shadow-3 '+themeCtx"
        v-loading="loading">
      <!-- <q-header elevated class="bg-black">
        <q-toolbar>
          <q-btn flat @click="drawer = !drawer" round dense icon="menu" />
          <q-toolbar-title>Header</q-toolbar-title>
        </q-toolbar>
      </q-header>-->

      <q-drawer
          v-model="$store.state.helpers.leftPanelOpen"
          show-if-above
          :width="calcWidth"
          :breakpoint="720"
          :class="themeCtx"
          :persistent="!autoCloseMenu"
          bordered
          :overlay="doOverlay"
          :behavior="searchMode?'mobile':'default'">

        <q-scroll-area
            class="fit"
            style="width: 100%">

          <slot></slot>

        </q-scroll-area>
      </q-drawer>
      <!--      <q-header reveal class="bg-black">-->
      <!--        <q-toolbar>-->
      <!--          <q-btn flat round dense icon="menu" />-->
      <!--          <q-toolbar-title>Header</q-toolbar-title>-->
      <!--          <q-btn flat  round dense icon="menu" />-->
      <!--        </q-toolbar>-->
      <!--      </q-header>-->
      <q-page-container v-if="!processingDrawer" >
        <q-layout container style="height:calc(100vh - 66px)">
          <transition
              name="fade"
              mode="out-in">
            <slot
                name="body"

                v-if="$slots['body']"></slot>

            <router-view
                v-else
                :key="refresh"
                @loading="loading=$event"
                @update="e=>$emit('update',e)"
                @refresh="e=>$emit('refresh',e)"
                @delete="e=>$emit('delete',e)"
                @done="e=>$emit('done',e)"
                @removeContact="$emit('removeContact',$event)"
                @updateBusiness="$emit('updateBusiness',$event)"/>
          </transition>
        </q-layout>
      </q-page-container>
    </q-layout>
  </div>
</template>
<script>
export default {
  name: "sc-panel-navigator",
  mounted() {
    _log_('MAIN LAYOUT')
    this.$store.commit('helpers/toggleLefPanel', this.initialDrawerOpen)
  },
  props: {
    initialDrawerOpen: {type: Boolean, default: true},
    processingDrawer: {type: Boolean, default: false},
    refresh: {
      type: [Number,
        String], default: 0
    },
    gutter: {
      type: Number,
      default: 30,
    },
    searchMode: {type: Boolean, default: false},
    drawerWidth: {
      type: Number,
      default: 300,
    },
    autoCloseMenu: {type: Boolean, default: false},
  },
  computed: {
    calcWidth() {

      return window.innerWidth < this.drawerWidth ? window.innerWidth : this.drawerWidth;
    },
    doOverlay() {
      if (this.searchMode !== false) return true
      const x = window.innerWidth / (window.innerWidth - this.drawerWidth);

      return x > 1.8;
    },
  },
  data() {
    return {vueTooglePanels: false, loading: false};
  },
};
</script>
<style>
.q-scrollarea__content.absolute {
  width: 100%;
  height: 100%;
}

.left_panel {
  position: relative;
  padding-top: 0px;
}

.right_panel {
  padding-left: 5px;
  height: calc(100vh - 62px);
  overflow: auto;
}

.vue_toogle_panels {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 50px;
  height: 60px;
  z-index: 13000;

  background: #095b69;
  color: #ffffff;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
}

.vue_toogle_panels .material-icons {
  font-size: 40px;
}

.flex {
  display: flex;
}

.col-1360-over {
  width: 25%;
  flex: 1 0 25%;
}

.col-1360-over-rest {
  width: 75%;
  flex: 1 0 75%;
}

.col-1360-over.right_full {
  width: 0%;
  flex: 1 0 0%;
}

.col-1360-over-rest.right_full {
  width: 100%;
  flex: 1 0 100%;
}

@media screen and (max-width: 1360px) {
  .col-1360 {
    width: 40%;
    flex: 1 0 40%;
  }

  .col-1360-rest {
    width: 60%;
    flex: 1 0 60%;
  }

  .col-1360.right_full {
    width: 0%;
    flex: 1 0 0%;
  }

  .col-1360-rest.right_full {
    width: 100%;
    flex: 1 0 100%;
  }
}

.dark .q-drawer {
  background-color: #095b69;
  color: antiquewhite;
}

@media screen and (max-width: 768px) {
  .col-768 {
    width: 100%;
    flex: 1 0 100%;
  }

  .col-768-rest {
    width: 100%;
    flex: 1 0 100%;
  }
}
</style>
